export default __webpack_public_path__ + "static/media/Centrifugal.a8502843.jpg";